import React, { useEffect } from "react";
import {
  I2cRadio,
  I2cListItem,
  I2cRadioGroup,
  I2cInput,
} from "@webcomponents/i2cwebcomponents/dist/react";
import "../Prepaid.scss";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
export const textService = [
  { label: "Yes", value: "yes" },
  { label: "No", value: "no" },
  { label: "Other", value: "other" },
];
export const shortCodeAcquire = [
  { label: "Random Short Code", value: "random-short-code" },
  { label: "Dedicated Short Code", value: "dedicated-short-code" },
];
export const textPurpose = [
  { label: "Deliver alerts and notifications (MT Only)", value: "mt-only" },
  { label: "Dual communication (Both MO and MT)", value: "both-mo-and-mt" },
  { label: "N/A", value: "n/a" },
];
const MobileTextMessage = ({
  setAddFormData,
  addFormData,
  setFormValidStates,
  formDataJson,
  isFetching,
}) => {

const optionalString = Yup.string().optional();

  const validationSchema = Yup.object({

  ov_mtm_service_code: optionalString,

  ov_mtm_service_code_other: Yup.string().test(
    "other-required",
    "Please specify other option",
    function (val) {
      const code = this.parent.ov_mtm_service_code;
      if (code === "other") {
        return val && val.length > 0;
      }
      return true;
    }
  ),

  ov_mtm_service_short_code: Yup.string().test(
    "short-code",
    "Dedicated short code is required",
    function (val) {
      const code = this.parent.ov_mtm_service_code;

      if (code === "yes") {
        return !val || val.length > 0;
      }

      return true;
    }
  ),

  ov_mtm_service_use: optionalString,

});
  // Initialize React Hook Form with Yup resolver
  const methods = useForm({
    resolver: yupResolver(validationSchema),
    mode: "all",
    reValidateMode: "onChange",
    shouldUseNativeValidation: false,
    criteriaMode: "all",
    defaultValues: {
      ov_mtm_service_code: "",
      ov_mtm_service_code_other: "",
      ov_mtm_service_short_code: "",
      ov_mtm_service_use: "",
    },
  });

  // Controlls destructuring from the method
  const {
    control,
    formState: { errors },
  } = methods;

  const fields = [
    "ov_mtm_service_code",
    "ov_mtm_service_code_other",
    "ov_mtm_service_short_code",
    "ov_mtm_service_use",
  ];
  useEffect(() => {
    if (!isFetching && Object.keys(formDataJson ?? {}).length) {
      fields.forEach((field) => {
        methods.setValue(field, formDataJson[4]["4_4"][field] ?? "");
      });
      methods.trigger();
    }
  }, [isFetching]);

  // Trigger validation when component mounts
  React.useEffect(() => {
    methods.trigger();
  }, []);

  const handleValueChanges = () => {
    const values = methods.getValues();
    setAddFormData({
      ...addFormData,
      4: {
        ...addFormData["4"],
        "4_4": { ...values },
      },
    });
  };

  // Update form validation state when errors change
  React.useEffect(() => {
    const errorsLength = Object.keys(errors).length;
    if (errorsLength === 0) setFormValidStates("4_4", true);
    else setFormValidStates("4_4", false);
  }, [Object.keys(errors).length]);
  return (
    <React.Fragment>
      <div className="forms-instance">
        <div i2c-grid="grid gap-sm">
          <div i2c-grid="12">
            <div className="single-field-wrapper">
              <Controller
                name="ov_mtm_service_code"
                control={control}
                render={({ field }) => (
                  <I2cRadioGroup
                    label="Would you like to acquire a dedicated short code via i2c?"
                    {...field}
                    onI2cChange={(e) => {
                      if (e.target.value !== "yes") {
                        methods.setValue("ov_mtm_service_short_code", "");
                      }
                      if (e.target.value !== "other") {
                        methods.setValue("ov_mtm_service_code_other", "");
                      }
                      methods.setValue("ov_mtm_service_code", e.target.value);
                      methods.trigger();
                      handleValueChanges();
                    }}
                  >
                    <div i2c-grid="grid gap-sm">
                      {textService.map((radio, index) => (
                        <I2cListItem
                          key={index}
                          i2c-grid="4@md"
                          variant="receipt"
                          label={radio.label}
                          sublabel=" "
                          value=""
                          type="checkbox"
                          checked={
                            methods.watch("ov_mtm_service_code") === radio.value
                          }
                        >
                          <I2cRadio
                            slot="prefix"
                            checked={
                              methods.watch("ov_mtm_service_code") ===
                              radio.value
                            }
                            filled
                            value={radio.value}
                          />
                        </I2cListItem>
                      ))}
                    </div>
                  </I2cRadioGroup>
                )}
              />
            </div>
          </div>
          {methods.watch("ov_mtm_service_code") === "other" && (
            <div i2c-grid="12">
              <div i2c-grid="grid gap-sm">
                <div i2c-grid="4@md">
                  <div className="single-field-wrapper">
                    <Controller
                      name="ov_mtm_service_code_other"
                      control={control}
                      render={({ field }) => (
                        <I2cInput
                          {...field}
                          className="single-input-field"
                          placeholder="Please Specify"
                          size="large"
                          label="Enter Details"
                          name="ov_mtm_service_code_other"
                          value={methods.watch("ov_mtm_service_code_other")}
                          onI2cInput={(e) => {
                            methods.setValue("ov_mtm_service_code_other", e.target.value);
                            methods.trigger();
                            handleValueChanges();
                          }}
                          invalid={errors.ov_mtm_service_code_other ? true : false}
                        />
                      )}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
          <div i2c-grid="12">
            <div className="single-field-wrapper">
              <Controller
                name="ov_mtm_service_short_code"
                control={control}
                render={({ field }) => (
                  <I2cRadioGroup
                    label="What type of short code would you like to acquire?"
                    {...field}
                    onI2cChange={(e) => {
                      methods.setValue(
                        "ov_mtm_service_short_code",
                        e.target.value,
                      );
                      methods.trigger();
                      handleValueChanges();
                    }}
                  >
                    <div i2c-grid="grid gap-sm">
                      {shortCodeAcquire.map((radio, index) => (
                        <I2cListItem
                          key={index}
                          i2c-grid="4@md"
                          variant="receipt"
                          label={radio.label}
                          sublabel=" "
                          value=""
                          type="checkbox"
                          checked={
                            methods.getValues("ov_mtm_service_short_code") ===
                            radio.value
                          }
                        >
                          <I2cRadio
                            slot="prefix"
                            checked={
                              methods.getValues(
                                "ov_mtm_service_short_code",
                              ) === radio.value
                            }
                            filled
                            value={radio.value}
                          />
                        </I2cListItem>
                      ))}
                    </div>
                  </I2cRadioGroup>
                )}
              />
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default MobileTextMessage;
